require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./eventi-imparare-facendo-per-unarchitettura-intertestuale.json") })
        }
      }, "path---eventi-imparare-facendo-per-unarchitettura-intertestuale");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---eventi-imparare-facendo-per-unarchitettura-intertestuale!./.cache/json/eventi-imparare-facendo-per-unarchitettura-intertestuale.json
// module id = 656
// module chunks = 231608221292675